import { Action } from '@ngrx/store';
import { Order } from '@cemex-core/cmx-api';

export enum OneClickNextWorkingDayActionTypes {
  LOAD_NEXT_WORKING_DAY = '[One Click] Load next working day',
  LOAD_NEXT_WORKING_DAY_COMPLETE = '[One Click] Load next working day completed',
  RESET = '[One Click] next working day reset',
}

export class OneClickLoadNextWorkingDayAction implements Action {
  readonly type = OneClickNextWorkingDayActionTypes.LOAD_NEXT_WORKING_DAY;

  constructor(public payload: Order) {}
}

export class OneClickLoadNextWorkingDayCompleteAction implements Action {
  readonly type = OneClickNextWorkingDayActionTypes.LOAD_NEXT_WORKING_DAY_COMPLETE;

  constructor(public payload: Date) {}
}

export class OneClickResetNextWorkingDayAction implements Action {
  readonly type = OneClickNextWorkingDayActionTypes.RESET;

  constructor() {}
}

export type OneClickNextWorkingDayActions =
  | OneClickLoadNextWorkingDayAction
  | OneClickLoadNextWorkingDayCompleteAction
  | OneClickResetNextWorkingDayAction;
